import React from "react";
import { Div } from "./Styles";
import { Container } from "./StyledComponents";
import LoginRight from "./LoginRight";
import LoginLeft from "./LoginLeft";

const Login = () => {
  return (
    // <Container Flex height="100vh" minWidth="1024px">
    <Container
      Flex
      height="100vh"
      minWidth="1024px"
      style={{ overflow: "hidden" }}
    >
      {/* <Div width="50%" bg_color="#F8FAFB" position="relative"> */}

      <Div width="50%" position="relative" style={{ height: "100vh" }}>
        <LoginLeft />
      </Div>
      {/* <Div width="50%" bg_color="#FFFFFF"> */}
      <Div
        width="50%"
        bg_color="#FFFFFF"
        style={{
          minHeight: "100vh",
          padding: " 0",
        }}
      >
        <LoginRight />
      </Div>
    </Container>
  );
};

export default Login;
